
import * as Yup from "yup";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import EmployeeModel from "../../models/party/employee-model";
import { useEffect, useState } from "react";
import React from "react";
import { SelectField } from "../../core/select-field.component";
import { useGetEmployee, useGetEmployeeType } from "../../apiclient/party/useGetEmployeeApi";
import { Upload, UploadOnAddEvent } from "@progress/kendo-react-upload";
import { useGetDroppingPoint } from "../../apiclient/party/useGetDropingPointApi";
import { useGetUnions } from "../../apiclient/master/useGetUnionsApi";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import ImageUpload from "../../core/image-upload";

interface EmployeeEditProps {
    data: EmployeeModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const EmployeeEntry: React.FC<EmployeeEditProps> = ({ ...props }) => {
    let { data, onClose, isViewMode } = props;
    const title = data?.employeeId > 0 ? "Edit Employee" : "Add Employee";

    let initialValue: EmployeeModel = {
        employeeId: data?.employeeId ? data.employeeId : 0,
        employeeCode: data?.employeeCode,
        name: data?.name,
        employeeTypeId: data?.employeeTypeId ? data.employeeTypeId : 0,
        unionId: data?.unionId ? data.unionId : 0,
        address: data?.address,
        city: data?.city,
        pincode: data?.pincode,
        droppingPointId: data?.droppingPointId ? data.droppingPointId : 0,
        employeePhotoPath: data?.employeePhotoPath,
        panNumber: data?.panNumber,
        aadharNumber: data?.aadharNumber,
        rationcardNumber: data?.rationcardNumber,
        isActive: data?.employeeId > 0 ? data.isActive : true,

    };

    console.log(initialValue)
    const validationSchema = Yup.object().shape({
        //employeeCode: Yup.string().required("Required"),

        employeeCode: Yup.string()
            .required("Required")
            .test("check-duplicate-employeeCode", " Code already exists", (value) => {
                // Check if the employeeCode already exists in the list of existing codes
                return !existingEmployeeCodes.includes(value) ||
                    (data?.employeeCode && value === data.employeeCode)
            }),
        name: Yup.string()
            .required("Required")
            .test("check-duplicate-name", "Employee name already exists", (value) => {
                // Ensure the value is compared in a case-insensitive manner
                return (
                    value &&
                    !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
                    (data?.name && value === data.name) // Allow current name during update
                );
            }),



        //   address: Yup.string().required("Required"),
        //  city: Yup.string().required("Required"),
        // pincode: Yup.number()
        //     .required("Pincode is required")
        //     .min(100000, "Pincode must be at least 6 digits")
        //     .max(999999, "Pincode must not exceed 6 digits")
        //     .typeError("Pincode Invalid number"),
        // rationcardNumber: Yup.string()
        //     .length(10, "Rationcard Number must be exactly 10 digits")  // Ensure exactly 10 digits
        //     .matches(/^[0-9]{10}$/, "Rationcard Number must be a valid 10-digit number")  // Ensure only digits
        //     .required("Required"),
        // panNumber: Yup.string()
        //     .length(10, "PAN number must be 10 characters")
        //     .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, "Invalid PAN format")
        //     .required("Required"),
        // aadharNumber: Yup.string()
        //     .length(12, "Aadhar number must be 12 digits")
        //     .matches(/^[0-9]{12}$/, "Aadhar number must be a valid 12-digit number")
        //     .required("Required"),
    });


    const [existingEmployeeCodes, setExistingEmployeeCodes] = useState<string[]>([]);
    const [existingName, setExistingName] = useState<string[]>([]);


    const { data: fetchedEmployees } = useGetEmployee();

    const [dropingpointData, setDropingPointData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedDropingPoint } = useGetDroppingPoint();

    const [employeetypeData, setEmployeeTypeData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedEmployeeType } = useGetEmployeeType();

    const [unionData, setUnionData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedUnion } = useGetUnions();

    useEffect(() => {

        if (fetchedEmployees) {
            // Extract employee codes and PAN numbers from the fetched data
            setExistingName(fetchedEmployees.map((emp: any) => emp.name));
            setExistingEmployeeCodes(fetchedEmployees.map((emp: any) => emp.employeeCode));
        }
        if (fetchedDropingPoint) {
            const mappeddropingpoint = fetchedDropingPoint.map((dropingpoint: any) => ({
                value: dropingpoint.droppingpointId,
                label: dropingpoint.name,
            }));
            setDropingPointData(mappeddropingpoint);
        }
        if (fetchedEmployeeType) {
            const mappedemployetype = fetchedEmployeeType.map((employeetype: any) => ({
                value: employeetype.employeeTypeId,
                label: employeetype.name,
            }));
            setEmployeeTypeData(mappedemployetype);
        }
        if (fetchedUnion) {
            const mappedunion = fetchedUnion.map((union: any) => ({
                value: union.unionId,
                label: union.name,
            }));
            setUnionData(mappedunion);
        }
    }, [fetchedDropingPoint, fetchedEmployeeType, fetchedUnion, fetchedEmployees]);

    return (

        <>
            <FormikModelDialog
                width="70%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PARTY}
                postRoute="Employee/SaveEmployee"
                showAddAnother={true}
                isViewOnly={isViewMode}

                isUpDateEntityDetails={data?.employeeId > 0 ? true : false}

            >
                <div>
                    <div className="row">
                        <div className="col-2">
                            <InputField maxLength={6}
                                label="Code *"
                                name="employeeCode" />
                        </div>
                        <div className="col-3">
                            <InputField maxLength={20}
                                label="Name*"
                                name="name" />
                        </div>
                        <div className="col-4">
                            <InputField maxLength={200}
                                label="Address"
                                name="address" />
                        </div>

                        <div className="col-3">
                            <SelectField
                                label="Employee Type "
                                name="employeeTypeId"
                                options={employeetypeData}
                                unSelectValue={0}
                            />
                        </div>
                        <div className="col-4">
                            <SelectField
                                label=" Union "
                                name="unionId"
                                options={unionData}
                                unSelectValue={0}
                            />
                        </div>
                        <div className="col-4">
                            <SelectField
                                label="Dropping Point"
                                name="droppingPointId"
                                options={dropingpointData}
                                unSelectValue={0}
                            />
                        </div>
                        <div className="col-2">

                            <InputField
                                maxLength={20}
                                label="City"
                                name="city"
                            />
                        </div>
                        <div className="col-2">
                            <InputField
                                maxLength={6}
                                label="Pincode"
                                name="pincode"
                            />
                        </div>




                        <div className="col-4">
                            {/* <div className="row mt-1"> */}

                            <InputField
                                maxLength={10}
                                label="Pan Number"
                                name="panNumber"

                            />
                        </div>
                        {/* </div> */}
                        <div className="col-4">
                            <InputField
                                maxLength={10}
                                label="Ration Card Number"
                                name="rationcardNumber"

                            />
                        </div>
                        <div className="col-3">
                            <InputField
                                maxLength={12}
                                label="Aadhar Card Number"
                                name="aadharNumber"

                            />
                        </div>
                        <div className="col-6 ">
                            <label>Employee Image</label>
                            <ImageUpload></ImageUpload>
                        </div>
                        <div className="col-3">
                            <CheckboxField
                                label="Is Active ?"
                                name="isActive"
                                checkstyle={CheckBoxStyle.Normal}
                            />
                        </div>
                    </div>
                </div>



            </FormikModelDialog>
        </>
    );
};

export default EmployeeEntry;
